export class ConsentLevels {
    functional = true;
    analytics = true;
    advertisements: boolean;
    personalisation: boolean;
    empty = false;
}
